import {AbstractLocalStorageService} from "../abstract-local-storage.service";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ActAsUserLocalStorageService extends AbstractLocalStorageService<number> {

  constructor() {
    super();
    // Этот код должен выполняться при старте приложения в каждой вкладке
    window.addEventListener('storage', (event) => {
      // Нас интересует только изменение id пользователя
      if (event.key === this.getItemKey()) {
        if (event.oldValue !== event.newValue) {
          window.location.reload();
        }
      }
    });
  }

  protected getDefaultValue(): number {
    return null;
  }

  protected getItemKey(): string {
    return 'act-as-user-id';
  }
}
